module.exports = __webpack_public_path__ + "trust-marks-business-com.2840b5.png";